/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Production store URL for each country code.
 *
 * @author Mohamed yasar arabath M
 */

const StoreUrlProd = {
  STORE_URL: {
    TTO: 'https://latam.pearson.com',
    FIN: 'https://eu.pearson.com',
    BMU: 'https://pearson.com',
    CO: 'https://latam.pearson.com',
    BHR: 'https://menat.pearson.com',
    SLV: 'https://latam.pearson.com',
    HRV: 'https://eu.pearson.com',
    SGP: 'https://t2-apac.pearson.com',
    MEX: 'https://latam.pearson.com',
    GTM: 'https://latam.pearson.com',
    LUX: 'https://eu.pearson.com',
    LBN: 'https://t2-menat.pearson.com',
    IRL: 'https://pearson.com',
    QAT: 'https://menat.pearson.com',
    EST: 'https://eu.pearson.com',
    DEU: 'https://eu.pearson.com',
    UKR: 'https://eu.pearson.com',
    TWN: 'https://t3-apac.pearson.com',
    ASM: 'https://pearson.com',
    ZMB: 'https://sa.pearson.com',
    MCO: 'https://pearson.com',
    IND: 'https://india.pearson.com',
    PHL: 'https://t3-apac.pearson.com',
    ZAF: 'https://sa.pearson.com',
    AUT: 'https://eu.pearson.com',
    SAU: 'https://menat.pearson.com',
    CHN: 'https://pearson.com',
    DOM: 'https://latam.pearson.com',
    MAC: 'https://cn.pearson.com',
    PAN: 'https://latam.pearson.com',
    ISR: 'https://eu.pearson.com',
    UZB: 'https://eu.pearson.com',
    IRN: 'https://pearson.com',
    NOR: 'https://eu.pearson.com',
    FRA: 'https://eu.pearson.com',
    CHE: 'https://eu.pearson.com',
    BEL: 'https://eu.pearson.com',
    KAZ: 'https://eu.pearson.com',
    AUS: 'https://pearson.com',
    URY: 'https://latam.pearson.com',
    KEN: 'https://sa.pearson.com',
    CYM: 'https://latam.pearson.com',
    BRA: 'https://latam.pearson.com',
    IDN: 'https://t3-apac.pearson.com',
    JAM: 'https://latam.pearson.com',
    PER: 'https://latam.pearson.com',
    EGY: 'https://t2-menat.pearson.com',
    LIE: 'https://pearson.com',
    ARM: 'https://t3-apac.pearson.com',
    VNM: 'https://t3-apac.pearson.com',
    LKA: 'https://t3-apac.pearson.com',
    ARE: 'https://menat.pearson.com',
    THA: 'https://t3-apac.pearson.com',
    VEN: 'https://latam.pearson.com',
    SRB: 'https://eu.pearson.com',
    BHS: 'https://latam.pearson.com',
    NIC: 'https://latam.pearson.com',
    MAR: 'https://t2-menat.pearson.com',
    KWT: 'https://menat.pearson.com',
    CAN: 'https://pearson.com',
    CHL: 'https://latam.pearson.com',
    ARG: 'https://latam.pearson.com',
    SWE: 'https://eu.pearson.com',
    ECU: 'https://latam.pearson.com',
    PCN: 'https://pearson.com',
    OMN: 'https://menat.pearson.com',
    MO: 'https://cn.pearson.com',
    NZL: 'https://pearson.com',
    CMR: 'https://sa.pearson.com',
    USA: 'https://pearson.com',
    SJM: 'https://pearson.com',
    POL: 'https://eu.pearson.com',
    JOR: 'https://t2-menat.pearson.com',
    COL: 'https://latam.pearson.com',
    GEO: 'https://t3-apac.pearson.com',
    ESP: 'https://eu.pearson.com',
    MYS: 'https://t3-apac.pearson.com',
    LVA: 'https://eu.pearson.com',
    CXR: 'https://pearson.com',
    BWA: 'https://sa.pearson.com',
    GBR: 'https://pearson.com',
    TUR: 'https://t3-menat.pearson.com',
    MKD: 'https://pearson.com',
    GUM: 'https://pearson.com',
    PRY: 'https://latam.pearson.com',
    CRI: 'https://latam.pearson.com',
    HND: 'https://latam.pearson.com',
    BG: 'https://eu.pearson.com',
    HKG: 'https://cn.pearson.com',
    PSE: 'https://eu.pearson.com',
    NLD: 'https://eu.pearson.com',
    AZE: 'https://t3-apac.pearson.com',
    BLZ: 'https://latam.pearson.com',
    DNK: 'https://eu.pearson.com',
    ISL: 'https://eu.pearson.com',
    JPN: 'https://t2-apac.pearson.com',
    BOL: 'https://latam.pearson.com',
    PRT: 'https://eu.pearson.com',
    ITA: 'https://eu.pearson.com',
    LTU: 'https://eu.pearson.com',
    ALB: 'https://eu.pearson.com',
    BIH: 'https://eu.pearson.com',
    CYP: 'https://eu.pearson.com',
    CZE: 'https://eu.pearson.com',
    GRC: 'https://eu.pearson.com',
    HUN: 'https://eu.pearson.com',
    XKX: 'https://eu.pearson.com',
    KGZ: 'https://eu.pearson.com',
    MLT: 'https://eu.pearson.com',
    MTQ: 'https://eu.pearson.com',
    MDA: 'https://eu.pearson.com',
    MNG: 'https://eu.pearson.com',
    MNE: 'https://eu.pearson.com',
    ROU: 'https://eu.pearson.com',
    SVK: 'https://eu.pearson.com',
    SVN: 'https://eu.pearson.com',
    IRQ: 'https://menat.pearson.com',
    LBY: 'https://t3-menat.pearson.com',
    NGA: 'https://t3-menat.pearson.com',
    PAK: 'https://t3-menat.pearson.com',
    SSD: 'https://t3-menat.pearson.com',
    SDN: 'https://t3-menat.pearson.com',
    SYR: 'https://t3-menat.pearson.com',
    TUN: 'https://t3-menat.pearson.com',
    YEM: 'https://t3-menat.pearson.com',
    DZA: 'https://sa.pearson.com',
    AGO: 'https://sa.pearson.com',
    BEN: 'https://sa.pearson.com',
    BFA: 'https://sa.pearson.com',
    BDI: 'https://sa.pearson.com',
    CPV: 'https://sa.pearson.com',
    CAF: 'https://sa.pearson.com',
    TCD: 'https://sa.pearson.com',
    COM: 'https://sa.pearson.com',
    COG: 'https://sa.pearson.com',
    CIV: 'https://sa.pearson.com',
    DJI: 'https://sa.pearson.com',
    COD: 'https://sa.pearson.com',
    GNQ: 'https://sa.pearson.com',
    ERI: 'https://sa.pearson.com',
    SWZ: 'https://sa.pearson.com',
    ETH: 'https://sa.pearson.com',
    GAB: 'https://sa.pearson.com',
    GMB: 'https://sa.pearson.com',
    GHA: 'https://sa.pearson.com',
    GIN: 'https://sa.pearson.com',
    GNB: 'https://sa.pearson.com',
    LSO: 'https://sa.pearson.com',
    LBR: 'https://sa.pearson.com',
    MDG: 'https://sa.pearson.com',
    MWI: 'https://sa.pearson.com',
    MLI: 'https://sa.pearson.com',
    MRT: 'https://sa.pearson.com',
    MUS: 'https://sa.pearson.com',
    MOZ: 'https://sa.pearson.com',
    NAM: 'https://sa.pearson.com',
    NER: 'https://sa.pearson.com',
    RWA: 'https://sa.pearson.com',
    STP: 'https://sa.pearson.com',
    SEN: 'https://sa.pearson.com',
    SYC: 'https://sa.pearson.com',
    SLE: 'https://sa.pearson.com',
    SOM: 'https://sa.pearson.com',
    TZA: 'https://sa.pearson.com',
    TGO: 'https://sa.pearson.com',
    UGA: 'https://sa.pearson.com',
    ZWE: 'https://sa.pearson.com',
    KOR: 'https://t2-apac.pearson.com',
    MMR: 'https://t3-apac.pearson.com',
    NPL: 'https://t3-apac.pearson.com',
    KHM: 'https://t3-apac.pearson.com',
    TJK: 'https://t3-apac.pearson.com',
    LAO: 'https://t3-apac.pearson.com',
    TKM: 'https://t3-apac.pearson.com',
    TLS: 'https://t3-apac.pearson.com',
    BTN: 'https://t3-apac.pearson.com',
    MDV: 'https://t3-apac.pearson.com',
    BRN: 'https://t3-apac.pearson.com',
    BGD: 'https://t3-apac.pearson.com',
    AIA: 'https://latam.pearson.com',
    ATG: 'https://latam.pearson.com',
    ABW: 'https://latam.pearson.com',
    BRB: 'https://latam.pearson.com',
    VGB: 'https://latam.pearson.com',
    BES: 'https://latam.pearson.com',
    CUW: 'https://latam.pearson.com',
    DMA: 'https://latam.pearson.com',
    FLK: 'https://latam.pearson.com',
    GUF: 'https://latam.pearson.com',
    GRD: 'https://latam.pearson.com',
    GLP: 'https://latam.pearson.com',
    GUY: 'https://latam.pearson.com',
    HTI: 'https://latam.pearson.com',
    MSR: 'https://latam.pearson.com',
    KNA: 'https://latam.pearson.com',
    LCA: 'https://latam.pearson.com',
    SXM: 'https://latam.pearson.com',
    VCT: 'https://latam.pearson.com',
    SUR: 'https://latam.pearson.com',
    TCA: 'https://latam.pearson.com',
    VIR: 'https://latam.pearson.com'
  }
};

export default StoreUrlProd;
